import { ReactNode } from 'react'
import { useOnboarding } from '../onboarding-provider'
import { Navigate, useLocation } from 'react-router-dom'

export type RequiresOnboardingCompletionProps = {
  children: ReactNode,
}

export function RequiresOnboardingCompletion({ children }: RequiresOnboardingCompletionProps) {
  const { getCurrentStageRoute, hasCompletedOnboarding } = useOnboarding()
  const location = useLocation()

  if (!hasCompletedOnboarding && location.pathname === getCurrentStageRoute()) {
    return children
  }

  return (
    <div>
      { hasCompletedOnboarding
        ? children
        : <Navigate
          to={getCurrentStageRoute()}
          replace
        /> }
    </div>
  )
}
